function updateRemainingTime() {
    const cutoffHour = 13; // Cutoff-Zeit (13 Uhr)
    const now = new Date();

    // Berechnung der nächsten Cutoff-Zeit
    let cutoffTime = new Date(now);

    if (now.getHours() < cutoffHour) {
        // Wenn es vor 13 Uhr ist, bleibt die Cutoff-Zeit heute um 13 Uhr
        cutoffTime.setHours(cutoffHour, 0, 0, 0);
    } else {
        // Wenn es nach 13 Uhr ist, setze die Cutoff-Zeit auf morgen 13 Uhr
        cutoffTime.setDate(now.getDate() + 1);
        cutoffTime.setHours(cutoffHour, 0, 0, 0);
    }

    // Berechnung des Lieferdatums basierend auf den Regeln
    let deliveryDate = new Date(cutoffTime); // Starte mit der nächsten Cutoff-Zeit

    const currentDay = now.getDay();
    if (currentDay >= 1 && currentDay <= 3) {
        // Montag bis Mittwoch -> Lieferung am nächsten Tag
        deliveryDate.setDate(cutoffTime.getDate() + 1);
    } else if (currentDay === 4) {
        // Donnerstag -> Lieferung am Freitag
        deliveryDate.setDate(cutoffTime.getDate() + 1);
    } else if (currentDay === 5) {
        // Freitag -> Lieferung am Montag
        deliveryDate.setDate(cutoffTime.getDate() + (now.getHours() < cutoffHour ? 3 : 4));
    } else if (currentDay === 6) {
        // Samstag -> Lieferung am Dienstag
        deliveryDate.setDate(cutoffTime.getDate() + 3);
    } else if (currentDay === 0) {
        // Sonntag -> Lieferung am Dienstag
        deliveryDate.setDate(cutoffTime.getDate() + 2);
    }

    // Berechnung der verbleibenden Stunden und Minuten bis zur nächsten Cutoff-Zeit
    const timeDifference = cutoffTime - now; // Zeitdifferenz bis zur nächsten Cutoff-Zeit
    const remainingHours = Math.floor(timeDifference / (1000 * 60 * 60));
    const remainingMinutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

    // Deutsche Wochentage und Monate
    const daysOfWeek = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
    const monthsOfYear = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

    // Formatierung des Lieferdatums
    const deliveryDayText = daysOfWeek[deliveryDate.getDay()];
    const deliveryDayOfMonth = deliveryDate.getDate();
    const deliveryMonth = monthsOfYear[deliveryDate.getMonth()];

    // Dynamische Ausgabe des Lieferdatums und der verbleibenden Zeit
    document.getElementById("delivery-day").innerText = deliveryDayText;
    document.getElementById("delivery-date").innerText = `${deliveryDayOfMonth}. ${deliveryMonth}`;
    document.getElementById("remaining-time").innerText = `${remainingHours} Std. ${remainingMinutes} Min.`;
}

function startCountdown() {
    // Starte die erste Aktualisierung sofort
    updateRemainingTime();

    // Berechne die verbleibenden Sekunden bis zur nächsten vollen Minute
    const now = new Date();
    const secondsUntilNextMinute = 60 - now.getSeconds();

    // Starte die nächste Aktualisierung zur vollen Minute
    setTimeout(function() {
        // Nach den verstrichenen Sekunden bis zur vollen Minute den Countdown auf 60-Sekunden-Intervalle setzen
        updateRemainingTime();
        setInterval(updateRemainingTime, 60000); // Aktualisierung jede Minute
    }, secondsUntilNextMinute * 1000);
}

// Starte den Countdown beim Laden der Seite
document.addEventListener("DOMContentLoaded", startCountdown);
